import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { getIsUngatedForCollections // @ts-expect-error untyped module
} from '../selectors/auth';
import AllThemeCollectionsContainer from './containers/AllThemeCollectionsContainer';
import StorefrontUsageTrackerProvider from '../context/StorefrontUsageTrackerProvider';
import TemplatesHomeContainer from './containers/TemplatesHomeContainer';
export default function TemplatesRoutes() {
  const {
    path
  } = useRouteMatch();
  const isUngatedForCollections = useSelector(getIsUngatedForCollections);

  if (isUngatedForCollections) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: path,
        exact: true,
        children: /*#__PURE__*/_jsx(TemplatesHomeContainer, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: `${path}/featured`,
        exact: true,
        children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
          children: /*#__PURE__*/_jsx(AllThemeCollectionsContainer, {})
        })
      }), /*#__PURE__*/_jsx(Redirect, {
        to: path
      })]
    });
  }

  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: path,
      exact: true,
      children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
        children: /*#__PURE__*/_jsx(TemplatesHomeContainer, {})
      })
    }), /*#__PURE__*/_jsx(Redirect, {
      to: path
    })]
  });
}